import { BaseQuestionnaireRoute } from '../slice';

type SpouseIncomeSubRoutes = {
  dividends: BaseQuestionnaireRoute;
  interest: BaseQuestionnaireRoute;
  pension: BaseQuestionnaireRoute;
  wages: BaseQuestionnaireRoute;
};

export type SpouseIncomeRoutes = BaseQuestionnaireRoute & SpouseIncomeSubRoutes;

export const spouseIncomeRoutes: {
  spouseIncome: SpouseIncomeRoutes;
} = {
  spouseIncome: {
    title: 'Spouse Income',
    path: 'spouseIncome',
    isValid: undefined,
    dividends: {
      title: 'Dividends',
      path: 'dividends',
      isValid: undefined,
    },
    interest: {
      title: 'Interest',
      path: 'interest',
      isValid: undefined,
    },
    pension: {
      title: 'Pension',
      path: 'pension',
      isValid: undefined,
    },
    wages: {
      title: 'Wages',
      path: 'wages',
      isValid: undefined,
    },
  },
};
